import { showModal } from '../helpers/modal.js';
import {logClient} from '../helpers/adminHelper.js';

export async function getFormData() {
    try {

        const response = await fetch(`/api/session/get-session-data`, {
            method: 'GET',
            credentials: 'include',
        });
        
        // Check for HTTP errors
        if (!response.ok) {
            throw new Error(`getFormData: HTTP error ${response.status} - ${response.statusText}`);
        }

        const result = await response.json();

        if (!result.success) {
            throw new Error(`getFormData: API error ${result.message || 'Unknown error'}`);
        }

        const sessionData = result.data || {};

        if (sessionData.paypalResponse) {
            delete sessionData.paypalResponse; 
        }

        return sessionData;

    } catch (error) {
        logClient('getFormData', 'Error occurred while fetching data', {
            message: error.message || 'Unknown error',
            errorCode: error.errorCode || 'Unknown error code',
        });
        return null;
    }
}

export async function clearFormFromSession() {

    try {

        const response = await fetch(`/api/session/clear-session-data`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Accept': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`clearFormFromSession: HTTP error ${response.status} - ${response.statusText}`);
        }

        let result;
        try {
            result = await response.json();
        } catch (jsonError) {
            throw new Error(`clearFormFromSession: Failed to parse JSON response - ${jsonError.message}`);
        }

        if (!result.success) {
            throw new Error(`clearFormFromSession: API error - ${result.message || 'Unknown error'}`);
        }

        return true;

    } catch (error) {
        logClient('clearFormFromSession', 'Error clearing session data', {
            message: error.message || 'Unknown error',
        });
        return false;
    }
}
export function initializeToolTipValidation(form) {
    const requiredFields = form.querySelectorAll('input[required], select[required], textarea[required]');
    
    requiredFields.forEach(field => {
        // Create a tooltip element for this field
        let tooltip = document.createElement('div');
        tooltip.classList.add('custom-tooltip');

        // Create an icon element
        let icon = document.createElement('div');
        icon.classList.add('tooltip-icon');
        icon.textContent = '!';
        tooltip.appendChild(icon);
        
        // Create a text container
        let text = document.createElement('div');
        text.classList.add('tooltip-text');
        tooltip.appendChild(text);
        
        // Append the tooltip to the document body
        document.body.appendChild(tooltip);
        
        // Helper function to position the tooltip near the field
        function positionTooltip() {
            const rect = field.getBoundingClientRect();
            // Position the tooltip above the field with a small gap
            tooltip.style.top = `${rect.bottom + window.scrollY + 5}px`;
            tooltip.style.left = `${rect.left + window.scrollX}px`;
        }

        let tooltipTimer; // To store the timeout ID
        
        // On blur, delay showing the tooltip
        field.addEventListener('blur', () => {
            tooltipTimer = setTimeout(() => {
                if (!field.checkValidity()) {
                    // Update only the text container so the icon remains intact
                    text.innerHTML = `<span>Required</span><br>` + (field.getAttribute('title') || 'Please fill out this field.');
                    positionTooltip();
                    tooltip.style.display = 'flex';
                }
            }, 150); // Adjust the delay (in ms) as needed
        });

        // On focus, cancel any scheduled tooltip and hide all tooltips
        field.addEventListener('focus', () => {
            clearTimeout(tooltipTimer);
            document.querySelectorAll('.custom-tooltip').forEach(tip => {
                tip.style.display = 'none';
            });
        });
        
        
        // Hide the tooltip when the field becomes valid as the user types
        field.addEventListener('input', () => {
            if (field.checkValidity()) {
                text.innerHTML = '';
                tooltip.style.display = 'none';
            }
        });

        
        // Optionally update tooltip position on window scroll/resize
        window.addEventListener('resize', () => {
            if (tooltip.style.display === 'flex') {
                positionTooltip();
            }
        });
        window.addEventListener('scroll', () => {
            if (tooltip.style.display === 'flex') {
                positionTooltip();
            }
        });
    });
}



// export function initializeValidation(form) {

//     const requiredFields = form.querySelectorAll('input[required], select[required], textarea[required]');

//     requiredFields.forEach(field => {

//         field.addEventListener('blur', () => {
//             if (!field.checkValidity()) {
//                 field.setCustomValidity(field.title || "Please fill out this field.");
//                 field.reportValidity();
//             } else {
//                 field.setCustomValidity("");
//             }
//         });
//         // Clear validation message on input for inputs and dropdowns
//         field.addEventListener('input', () => {
//             if (field.tagName.toLowerCase() === 'select' || field.tagName.toLowerCase() === 'textarea') {
//                 if (field.value) {
//                     field.setCustomValidity("");
//                 }
//             } else {
//                 field.setCustomValidity("");
//             }
//         });
//     });
// }

export function initializeShippingValidation(zipCodeInput, mailClassSelect, calculateShippingCallback) {
    if (!zipCodeInput || !mailClassSelect) {
        return;
    }

    mailClassSelect.addEventListener('change', calculateShippingCallback);
    zipCodeInput.addEventListener('change', calculateShippingCallback);

    mailClassSelect.addEventListener('blur', () => {});
    zipCodeInput.addEventListener('blur', () => {});
}


export async function saveCustomerEmail(email) {
    if (!email) {
        logClient('saveCustomerEmail', 'No email address provided.', { message: 'Email parameter is missing.' });
        return;
    }
    try {
        const response = await fetch('/api/checkout/save-email-address', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email}),
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(`saveCustomerEmail: HTTP error ${response.status} - ${response.statusText}`);
        }

        if (!result.success) {
            throw new Error(`saveCustomerEmail: API error - ${result.message || 'Unknown error'}`);
        }

    } catch (error) {
        logClient('saveCustomerEmail', 'Error saving email address', {
            message: error.message || 'Unknown error',
        });
    }
}

export function initializeFormHandling(checkoutForm) {

    let debounceTimer;

const saveFormData = async () => {
    
    clearTimeout(debounceTimer); // Clear any pending save requests

    debounceTimer = setTimeout(async () => {
        
        try {

            const formData = new FormData(checkoutForm);
            const formObject = {};

            formData.forEach((value, key) => {
                formObject[key] = value;
            });

            const checkboxes = checkoutForm.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach((checkbox) => {
                formObject[checkbox.name || checkbox.id] = checkbox.checked;
            });

            const response = await fetch('/api/session/save-session-data', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ formData: formObject }), 
            });

            const data = await response.json();

            if (!response.ok || !data.success) { 

                const message = data.message || 'Failed to save form data to session';

                showModal(`<p>${data.message}</p>` || `<p>Your checkout session has expired. Please refresh the page and re-enter your information to continue.</p>`, {
                    errorCode: data.errorCode || 'No errrorCode passed in data',
                    disableClickToClose: true,
                });

                throw new Error(`saveFormData: API error - ${message}`);
            }

        } catch (error) {
            logClient('initializeFormHandling', 'Error saving form data', {
                message: error.message || 'Unknown error',
            });
        }
    }, 1000); // Debounce delay

};

    const fields = checkoutForm.querySelectorAll('input, select, textarea');
    fields.forEach((field) => {
        field.addEventListener('input', saveFormData);
        field.addEventListener('change', saveFormData);
    });

    return {saveFormData};
}


export async function restoreFormData(checkoutForm) {
    try {

        const sessionData = await getFormData();
        const cartData = JSON.parse(localStorage.getItem('cart')) || [];

        if (cartData.length === 0 || !sessionData || !sessionData.checkoutForm || Object.keys(sessionData.checkoutForm).length === 0) {
            return;
        }

        Object.entries(sessionData.checkoutForm).forEach(([key, value]) => {
            const formField = checkoutForm.elements[key];
            if (formField) {
                if (formField.type === 'checkbox') {
                    formField.checked = value;
                    formField.dispatchEvent(new Event('change'));
                } else {
                    formField.value = value;
                }
            }
        });

    } catch (error) {
        logClient('restoreFormData', 'Error restoring form data', {
            message: error.message || 'Unknown error',
        });
    }
}

export function clearFieldsOnCheckboxToggle(checkbox, fieldsToClear, saveFormData) {
    checkbox.addEventListener('change', () => {
        if (!checkbox.checked) {
            fieldsToClear.forEach((field) => {
                field.value = '';
                field.dispatchEvent(new Event('input', { bubbles: true }));
            });
            saveFormData();
        }
    });
}

export function initializeSynchronization(
    checkbox,
    sourceFields,
    targetFields,
    saveFormData
) {
    let stopSync = null;
    let isSyncing = false;

    const synchronizeFields = (fromFields, toFields) => {
        fromFields.forEach((fromField, index) => {
            const toField = toFields[index];
            if (fromField && toField) {
                toField.value = fromField.value;
                toField.dispatchEvent(new Event('input', { bubbles: true }));
            }
        });

    saveFormData();
    };

    const validateSynchronization = () => {
        for (let i = 0; i < sourceFields.length; i++) {
            if (
                sourceFields[i].value !== targetFields[i].value &&
                checkbox.checked
            ) {

                showModal(
                    `<h4>Billing and shipping fields don't match. What would you like to do?</h4>`, {
                    confirmCallback: () => {
                        checkbox.checked = false;
                        handleCheckboxChange();
                    },
                    cancelCallback: () => {
                        synchronizeFields(sourceFields, targetFields);
                        saveFormData();
                    },
                    yesText: 'Use Different Billing Information',
                    noText: 'Revert Changes'
                });
                break;
            }
        }
    };

    const startSyncing = () => {
        stopSync = () => {
            sourceFields.forEach((sourceField, index) => {
                const targetField = targetFields[index];
                if (sourceField && targetField) {
                    sourceField.removeEventListener('input', syncListener);
                    sourceField.removeEventListener('change', syncListener);
                }
            });
        };

        const syncListener = () => {
            if (!isSyncing) {
                isSyncing = true;
                synchronizeFields(sourceFields, targetFields);
                isSyncing = false;
            }
        };

        sourceFields.forEach((sourceField, index) => {
            const targetField = targetFields[index];
            if (sourceField && targetField) {
                sourceField.addEventListener('input', syncListener);
                sourceField.addEventListener('change', syncListener);
            }
        });

        sourceFields.forEach((field) => {
            field.addEventListener('blur', validateSynchronization);
        });
        targetFields.forEach((field) => {
            field.addEventListener('blur', validateSynchronization);
        });

        synchronizeFields(sourceFields, targetFields);
    };

    const handleCheckboxChange = () => {
        if (checkbox.checked) {
            startSyncing();
        } else if (stopSync) {
            stopSync();
            isSyncing = true;
            targetFields.forEach((field) => {
                field.value = '';
                field.dispatchEvent(new Event('input', { bubbles: true }));
            });
            isSyncing = false;
            saveFormData();
        }
    };

    checkbox.addEventListener('change', handleCheckboxChange);

    if (checkbox.checked) {
        handleCheckboxChange();
    }
}

export function initializeClearForm(checkoutForm, clearFormButton, showModal, resetTotals){
    if (!checkoutForm || !clearFormButton) {
        return;
    }

    function isFormCleared(form) {
        // Check text-based fields using FormData.
        const formData = new FormData(form);
        for (let [key, value] of formData.entries()) {
          // If any value is non-empty, the form isn't cleared.
          if (typeof value === 'string' && value.trim() !== '') {
            return false;
          }
        }
        // Check checkboxes separately.
        const checkboxes = form.querySelectorAll('input[type="checkbox"]');
        for (let checkbox of checkboxes) {
          // Assuming the default state for a cleared form is unchecked.
          if (checkbox.checked) {
            return false;
          }
        }
        return true;
      }
      
    clearFormButton.addEventListener('click', (e) => {
        e.preventDefault();

        if (isFormCleared(checkoutForm)) {
            showModal('<h4>The form is already cleared.</h4>', {
              disableClickToClose: false,
            });
            return;
          }

        showModal('<h4>Are you sure you want to clear all the form fields?</h4>', {
            confirmCallback: async () => {
        
                const cleared = await clearFormFromSession();
        
                if (cleared) {
                    checkoutForm.reset();
        
                    if (typeof resetTotals === 'function') {
                        resetTotals();
                    }
                } else {
                    showModal('<p>Failed to clear form data. Please try again.</p>', {
                        disableClickToClose: false, 
                    });
                }
            },
            cancelCallback: () => {},
            yesText: 'Clear Form',
            noText: 'Cancel',
        });
    });
}


export function initializePhoneFormatting(phoneInput) {
    if (!phoneInput) {
        return;
    }

    phoneInput.addEventListener('input', function (e) {
        let input = e.target.value;

        // Allow only digits, spaces, hyphens, and an optional leading '+'
        input = input.replace(/[^\d\s\-\+]/g, '');

        // Automatically handle U.S.-specific formatting for 10-digit numbers
        const cleanedInput = input.replace(/\D/g, '');
        if (cleanedInput.length === 10 && !input.startsWith('+')) {
            const part1 = cleanedInput.substring(0, 3);
            const part2 = cleanedInput.substring(3, 6);
            const part3 = cleanedInput.substring(6, 10);
            e.target.value = `(${part1}) ${part2}-${part3}`;
        } else {
            // Allow international format with flexible separators
            e.target.value = input;
        }
    });
}
